import { telesalesMachine } from '~/machines/telesales-funnel';
import { getInitialState } from '~/utils/funnels';
import { config } from './config';

export const funnelMachine = () =>
  telesalesMachine({
    id: config.id,
    initialState: getInitialState(config.id, telesalesMachine),
  });
